
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living/travel-and-accommodation",
      function () {
        return require("private-next-pages/living/travel-and-accommodation.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living/travel-and-accommodation"])
      });
    }
  